export default "__VITE_ASSET__92efa1f2__"